import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Compass, Home, Map, Sprout } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Eyebrow } from "../components/common";

function titleFromPath(pathname) {
  const seg = pathname.split("/").filter(Boolean);
  if (!seg.length) return "Page";
  return seg[seg.length - 1]
    .split("-")
    .map((w) => (w.toLowerCase() === "ivi" ? "IVI" : w.charAt(0).toUpperCase() + w.slice(1)))
    .join(" ");
}

const LINKS = [
  { to: "/", label: "Homepage", icon: Home, text: "Programs, films, reviews and destinations" },
  {
    to: "/projects/volunteer-in-bali",
    label: "Volunteer in Bali",
    icon: Sprout,
    text: "13 projects, from turtles to kindergartens",
  },
  {
    to: "/blog/find-out-more-about-cape-verde",
    label: "Cape Verde guide",
    icon: Compass,
    text: "Our newest destination, explained",
  },
  { to: "/sitemap", label: "Full sitemap", icon: Map, text: "All 1,300 pages, organised" },
];

export default function Placeholder() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="bg-white">
      <Navbar />

      <section className="bg-ivi-mint pb-20 pt-36">
        <div className="mx-auto max-w-[900px] px-5 text-center lg:px-8">
          <Eyebrow>Not built yet</Eyebrow>
          <h1 className="mt-5 font-heading text-[36px] font-extrabold leading-[1.1] tracking-[-0.02em] text-ivi-slate sm:text-[48px]">
            {titleFromPath(pathname)}
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-ivi-slateSoft">
            This page exists in the IVI sitemap but hasn&apos;t been designed in this prototype yet.
            The homepage, the Bali destination page, the Cape Verde article and the full HTML sitemap
            are all live pick one below.
          </p>
          <code className="mt-6 inline-block rounded-full bg-white px-5 py-2 font-mono text-[13px] text-ivi-slateSoft">
            {pathname}
          </code>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="mx-auto grid max-w-[1100px] gap-5 px-5 sm:grid-cols-2 lg:px-8">
          {LINKS.map(({ to, label, icon: I, text }) => (
            <Link
              key={to}
              to={to}
              className="group flex items-start gap-4 rounded-3xl bg-ivi-sand p-7 transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:shadow-[0_26px_50px_-30px_rgba(24,40,32,0.5)]"
            >
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-white text-ivi-greenDark transition-colors duration-300 group-hover:bg-ivi-green group-hover:text-white">
                <I className="h-5 w-5" />
              </span>
              <span>
                <span className="flex items-center gap-2 font-heading text-[18px] font-extrabold text-ivi-slate">
                  {label}
                  <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                </span>
                <span className="mt-1.5 block text-[14px] leading-relaxed text-ivi-slateSoft">
                  {text}
                </span>
              </span>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
